import { dangerListItemStyles } from './DangerListItem.styles';
import { standardListItemStyles } from './StandardListItem.styles';
export const listItemVariantStyles = {
    danger: dangerListItemStyles,
    standard: standardListItemStyles,
};
